import Papa from "papaparse";
import { translate } from "../../infrastructure/translate/localization";

export async function filterCsvEmployees({ filename }) {
  return new Promise((resolve) => {
    Papa.parse(filename, {
      header: false,
      skipEmptyLines: true,
      complete: async (results) => {
        const csvProperties = {
          isInvalid: false,
          errorMessage: "",
          result: [],
        };

        if (results.data.length === results.errors.length) {
          csvProperties.isInvalid = true;
          csvProperties.errorMessage =
            (results.errors[0] && results.errors[0].message) ||
            translate("upload-employees-section.invalid-csv");
        }

        if (!csvProperties.isInvalid) {
          const items = [];
          results.data.map((itemCsv) => {
            delete itemCsv[""];
            return items.push(itemCsv[0]);
          });
          csvProperties.result = items;
        }

        resolve(csvProperties);
      },
    });
  });
}
